export const SOLUTION_LOGO_UPDATED_EVENT = "solution-logo-updated"

export function getSolutionLogoUrlFromBody() {
  if (typeof document === "undefined") return ""
  return document.body?.dataset?.currentSolutionLogoUrl || ""
}

/** True for super admins and solution admins only (matches API + layout body flag). */
export function canManageCompanyLogoFromBody() {
  if (typeof document === "undefined") return false
  return document.body?.dataset?.canManageCompanyLogo === "true"
}

export function publishSolutionLogoUpdate(logoUrl) {
  if (typeof document !== "undefined" && document.body?.dataset) {
    document.body.dataset.currentSolutionLogoUrl = logoUrl || ""
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(SOLUTION_LOGO_UPDATED_EVENT, { detail: { logoUrl: logoUrl || "" } })
    )
  }
}
